$(document).ready(function(){
    $(".lightbox-header svg").click(function(){
        $(".customer-service-lightbox").toggleClass("open");
        $(".overlay_modal").toggle();
    });
    $(".overlay_modal").click(function(){
        $(".customer-service-lightbox").toggleClass("open");
        $(".overlay_modal").toggle();
    });
    $(".select-customer-page").click(function(){
        $(".customer-service-lightbox").toggleClass("open");
        $(".overlay_modal").toggle();
    });
    $("body").on("click", ".card-wrapper .card__inner", function (e) {
        if ($(e.target).closest("twa-variant-drawer-picker").length) {
            return;
        }
        var product_handle = $(this).attr("product-handle");
        window.location.href = product_handle;
    });
    $("body").on("click", ".card-wrapper .card .custom-hover-show > div", function () {
        var variant_url  = $(this).attr("variant-url");
        window.location.href = variant_url;
    });      

    function check_free_wipe() {
        var free_wipe_id = 44192183517424;
        $.getJSON('/cart.js', function (cart) {
            var cm_free_gift = false;
            var free_wipe_key = '';  
            for (let index = 0; index < cart.items.length; index++) {
                var line_item = cart.items[index];
                if (line_item.variant_id == free_wipe_id && line_item.properties.__free_gift_2023_cm == 'true') {
                    cm_free_gift = true;
                    free_wipe_key = line_item.key;
                }
            }
            if (cart.item_count > 1 && cm_free_gift == false ){
                $.ajax({
                    url: '/cart/add.js',
                    dataType: 'json',
                    type: 'post', 
                    data: {
                        "id": free_wipe_id,
                        "quantity": 1,
                        "properties" : {
                            '__free_gift_2023_cm': 'true'
                        }
                    }
                }).then(res => {
                    console.log("added free wipe");
                });
            }
            if (cart.item_count < 3 && cm_free_gift == true){
                $.ajax({
                    url: '/cart/update.js',
                    dataType: 'json',
                    type: 'post',
                    data: {
                        "updates": {
                            [`${free_wipe_key}`]: 0
                        }
                    }
                }).then( res => {
                    console.log("removed free wipe");
                });
            }
        });
    }

    // $(".product-form__buttons").on("click", function () {
    //     setTimeout(() => {
    //         check_free_wipe(); 
    //     }, 1000);      
    // });
    // $("body").on("click", "button.quantity__button", function () {
    //     setTimeout(() => {
    //         check_free_wipe(); 
    //     }, 1000);      
    // });
    // $("body").on("click", "cart-remove-button", function () {
    //     setTimeout(() => {
    //         check_free_wipe(); 
    //     }, 1000);      
    // });
}); 
  